import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { VoucherCreditServiceCodeOptionDto } from '../services/api.service';

export interface CreateCreditsFormValue {
  serviceCodeId: number;
  expiredDate: Date;
}

@Component({
  selector: 'cert-voucher-create-credits-form',
  standalone: false,
  templateUrl: './voucher-create-credits-form.component.html',
})
export class VoucherCreateCreditsFormComponent implements OnChanges {
  @Input() cycleStartDate: Date = new Date();
  @Input() serviceCodes: VoucherCreditServiceCodeOptionDto[] = [];
  @Input() disabled = false;

  @Output() create = new EventEmitter<CreateCreditsFormValue>();

  serviceCodeId: number | null = null;
  expiredDate: Date = this.computeMinExpiredDate();

  get minExpiredDate(): Date {
    return this.computeMinExpiredDate();
  }

  private computeMinExpiredDate(): Date {
    const today = new Date();
    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const cycleStart = new Date(this.cycleStartDate);
    const cycleMidnight = new Date(cycleStart.getFullYear(), cycleStart.getMonth(), cycleStart.getDate());
    const baseDate = cycleMidnight > todayMidnight ? cycleMidnight : todayMidnight;
    return new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate() + 14);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cycleStartDate'] && (!this.expiredDate || this.expiredDate < this.minExpiredDate)) {
      this.expiredDate = this.minExpiredDate;
    }
  }

  onSubmit() {
    if (!this.serviceCodeId || !this.expiredDate) return;
    this.create.emit({ serviceCodeId: this.serviceCodeId, expiredDate: this.expiredDate });
  }

  resetForm() {
    this.serviceCodeId = null;
    this.expiredDate = this.minExpiredDate;
  }
}
